const listPointsBody = document.querySelector('#catalog_films_in_programs_add-table-body');
// import auth from '../tools/storage.js';

export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index, curFilmsInProgram, arrFilmsWithoutProgram, onlyFreeFilms) {

    let inProgram = false;
    let freeFilm = false;
    curFilmsInProgram.forEach((fpElem) => {
      // console.log(fpElem);
      if(fpElem.filmIDfk  === item.id)
          inProgram = true;
    });
    // console.log(arrFilmsWithoutProgram);
    if(!inProgram && arrFilmsWithoutProgram)
      arrFilmsWithoutProgram.forEach((fwithoutPElem) => {
        // console.log(fwithoutPElem);
        if(fwithoutPElem.id  === item.id)
          freeFilm = true;
      });

    if(onlyFreeFilms)
      if(!(freeFilm || inProgram ))
        return '';

    let codeBT = `<button name="programFilmLinkAction" filmid="${item.id}" type="button" class="btn `;
    if (inProgram) 
      codeBT += ' remove_film_link "> Убрать';
    else
      codeBT += 'add_film_link "> Добавить';
    
    codeBT += '</button>';
    return `
    <label class="reference-header">
        <div class="reference-column" >${item.numRequest}</div>
        <div class="reference-column ${(!freeFilm && !inProgram) ? 'filmWithoutProgram' :''} ${inProgram ? 'filmInCurrentProgram' : ''}">${item.name}</div>
        <div class="reference-column">
          ${codeBT}
        </div>
    </label>`;
  },

  drawDataInContainer(enterprisesData , curFilmsInProgram, arrFilmsWithoutProgram , onlyFreeFilms) {
    // console.log(arrFilmsWithoutProgram);
    listPointsBody.innerHTML = `
    <div class="reference-header">
        <div class="reference-column">№</div>
        <div class="reference-column">Название</div>
        <div class="reference-column"></div>
       
    </div>
    `;
    enterprisesData.forEach((item, index) => listPointsBody.insertAdjacentHTML('beforeend', this.getElement(item, index, curFilmsInProgram, arrFilmsWithoutProgram, onlyFreeFilms)));
  },

  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
